let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jhksl")).then(() => parcelRequire('6jqe4'));